import * as RechartsPrimitive from "recharts"

const ChartGrid = RechartsPrimitive.CartesianGrid

export default ChartGrid
